import React from 'react';
import AuthService from './authService.js';
import ClientInvoiceAssignmentItem from '../Domain/ClientInvoiceAssignmentItem.js';
import SearchParams from '../Elements/SearchParams';
import ClientInvoiceAssignmentSearchParams from '../Contents/Operations/ClientInvoiceAdmin/Details/ClientInvoiceAssignmentSearchParams';

export default class VZeusAssignmentListInvoicedService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceAssignmentSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/VZeusAssignmentListInvoiced/GetAssignmentsForClientInvoiceAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientInvoiceAssignmentItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ExportToExcel(searchItem) {
    const searchParams = new SearchParams(searchItem, ClientInvoiceAssignmentSearchParams, '', '', 0, 0);
    return AuthService.getInstance().CallBackendFunction(
      `/api/VZeusAssignmentListInvoiced/ExportToExcelAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=false`
    );
  }
}
